// api configs
const config = {
  // apiUrl: 'http://localhost:3003',
  apiUrl: 'https://api.howdoyousay.org',
  headers: {
    // 'Content-Type': 'application/json;charset=UTF-8',
    // Accept: '*/*',This email is already used
    // 'Access-Control-Allow-Origin': '*'
    // 'Referrer-Policy': 'strict-origin-when-cross-origin',
    // Cookies: document.cookie
    // withCredentials: true
  }
}

// expots api config
module.exports = config
